<template>
  <v-app>
    <eps-login-header></eps-login-header>
    <v-content>
      <v-container class="fill-height" flemail>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="5">
            <v-card class="elevation-12">
              <v-toolbar class="app" dark flat>
                <v-toolbar-title>Parent Sign up</v-toolbar-title>
                <v-spacer />
              </v-toolbar>

              <v-card-text v-if="otp_block == true">
                <v-form>
                  <div class="note-red">
                Note : Kindly create your login credentials to fill the admission form.
              </div>
                  <v-text-field v-if="!is_mobile_signup"
                    v-model="user.email"
                    :rules="[rules.required, rules.email]"
                    prepend-icon="email"
                    placeholder="Please enter your valid email for signup"
                    clearable
                    required
                  ></v-text-field>
                  <v-text-field v-if="!allotment_signup_only"
                    v-model="user.mobile"
                    :rules="[rules.required, rules.mobile]"
                    prepend-icon="phone"
                    placeholder="Please enter your valid mobile no. for signup"
                    clearable
                    required
                  ></v-text-field>
                  <v-text-field v-if="allotment_signup_only"
                    v-model="user.mobile"
                    :rules="[rules.required]"
                    prepend-icon="mdi-application"
                    placeholder="Please enter your Application Id"
                    clearable
                    required
                  ></v-text-field>
                  <v-checkbox
                    v-model="policy_read"
                    label="I agree to receive emails / WhatsApp messages from School ERP"
                  ></v-checkbox>
                  <span v-if="is_mobile_signup"
                    ><b
                      >Above Mobile Number will be considered as
                      preferred communication details.</b
                    ></span
                  >
                  <span v-else>
                    <b>Above Email ID and Mobile Number will be considered as
                      preferred communication details.
                    </b>
                  </span>
                  <div class="error-message" v-if="error">
                    {{ error_message }}
                  </div>
                  <v-layout align-center justify-center v-if="hideen">
                    <v-btn
                      class="mr-4 button"
                      :disabled="!policy_read"
                      :loading="send_otp_btn_load"
                      @click="sendotp"
                      >Request OTP</v-btn
                    >
                  </v-layout>

                  <div class="error-message" v-if="error1">
                    {{ error_message1 }}
                  </div>
                </v-form>
              </v-card-text>
              <v-card-text v-if="verify_block == true">
                <v-form>
                  <v-row v-if="!is_mobile_signup">
                    <v-col sm="9">
                      <v-text-field
                        v-model="user.email_otp"
                        placeholder="Please Enter OTP"
                        hint="Enter OTP"
                        persistent-hint
                        clearable
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col sm="2">
                      <v-btn
                        class="button"
                        @click="resendOTP('email')"
                        :disabled="resend_email_otp_btn"
                        :loading="resend_email_otp_load"
                        title="Resend OTP"
                        >resend</v-btn
                      >
                    </v-col>
                  </v-row>

                  <v-row v-if="is_mobile_signup">
                    <v-col sm="10">
                  <v-text-field
                    v-model="user.mobile_otp"
                    placeholder="Please Enter Mobile-OTP"
                    clearable
                    required
                  ></v-text-field>
                  </v-col>
                    <v-col sm="2">
                       <v-btn class="button" @click="resendOTP('mobile')" :disabled="resend_mobile_otp_btn" :loading="resend_mobile_otp_load" title="Resend Mobile-OTP">resend</v-btn>
                    </v-col>
                  </v-row>
                  
                    <v-combobox
                    dense
                    required
                    v-model="org"
                    :items="org_list"
                    item-text="org_name"
                    item-value="org_id"
                    return-object
                    label="School"
                    hint="Select School"
                    persistent-hint
                    outlined
                    :readonly="org_locked"
                    :disabled="org_locked"
                    :class="{ 'readonly-combobox': org_locked }"
                    />
                  <v-layout align-center justify-center v-if="hideen">
                    <v-btn
                      class="mr-4 button"
                      :loading="verify_btn_load"
                      @click="verifyotp"
                      >Proceed</v-btn
                    >
                  </v-layout>
                  {{ email_msg }}
                  <!-- <br>{{mobile_msg}} -->
                </v-form>
              </v-card-text>
              <center>
                If already registered ?
                <router-link to="/" style="text-decoration: none" title="Login"
                  >Login
                </router-link>
              </center>
              <br />
              <center>
                <a v-if="guid_link != null" :href="guid_link" target="_blank">
                  How to sign up and fill admission form ?</a
                >
              </center>
              <br />
              <router-link to="/" style="text-decoration: none" title="Back">
                <v-icon large color="grey darken"
                  >mdi-chevron-left-circle</v-icon
                >
              </router-link>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <eps-login-footer></eps-login-footer>
  </v-app>
</template>

<script>
import axios from "axios";
import epsLoginHeader from "./LoginHeader.vue";
import epsLoginFooter from "./LoginFooter.vue";
export default {
  components: {
    epsLoginHeader: epsLoginHeader,
    epsLoginFooter: epsLoginFooter,
  },
  data() {
    return {
      user: {
        otp_id: "",
        email: "",
        email_otp: "",
        mobile: "",
        mobile_otp: "",
        org_code: "" 
      },
      is_mobile_signup : false,
      allotment_signup_only : false,
      resend_email_otp_btn: false,
      resend_mobile_otp_btn: false,
      email_msg: null,
      mobile_msg: null,
      otp_block: true,
      verify_block: false,
      org_code_from_url: null,
      org_locked: false,
      invalid_org_code: false,
      org_list: [],
      org: null,
      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        mobile: (value) => {
          const pattern = /[0-9]{10}/;
          return pattern.test(value);
        },
      },
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      hideen: true,
      disabled: 0,
      btnDisabled: true,
      message: "",
      dbemail_otp: "",
      error: false,
      error_message: "",
      error1: false,
      error_message1: "",
      policy_read: false,
      //loader
      verify_btn_load: false,
      send_otp_btn_load: false,
      resend_email_otp_load: false,
      resend_mobile_otp_load: false,
      guid_link: null,
    };
  },
  methods: {

    init() {
      axios
        .post("/login/checkSignupMethod", {
          dns: window.location.hostname, org_code: this.$route.query.ORG_CODE,
        })
        .then((res) => {
          if (res.data.msg === "200") {
            this.is_mobile_signup = res.data.is_mobile_signup;
            this.allotment_signup_only = res.data.allotment_signup_only;
          } else {
            this.is_mobile_signup = false;
            this.allotment_signup_only = false;
          }
        })
        .catch((error) => {
          console.error("checkSignupMethod error:", error);
          this.is_mobile_signup = false;
          this.allotment_signup_only = false;
        });
    },

    resendOTP(type) {
      //api-3
      var link = "";
      // if(type=="email"){
      //   link="resendEmailOTP"
      //   this.resend_email_otp_load=true
      // }
      // else if(type=="mobile"){
      //   link="resendMobileOTP"
      //   this.resend_mobile_otp_load=true
      // }
      this.resend_email_otp_btn = true;
      axios
        .post("/login/resendOTP", this.user)
        .then((res) => {
          console.log(res);
          if (res.data.status == "NO") {
            alert(res.data.status_reason);
          } else {
            this.email_msg = res.data.email_msg;
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.message = "Something went wrong";
        })
        .finally(() => {
          this.resend_email_otp_load = false;
          this.resend_mobile_otp_load = false;
          if (type == "email") {
            this.resend_email_otp_btn = true;
          } else if (type == "mobile") {
            this.resend_mobile_otp_btn = true;
          }
        });
    },

    sendotp() {
      //api-1
      this.send_otp_btn_load = true;
      this.user.dns = window.location.hostname;
      axios
        .post("/login/sendotp", this.user)
        .then((res) => {
          console.log(res);
          if (res.data.status == "NO") {
            alert(res.data.status_reason);
          } else {
            this.otp_block = false;
            this.verify_block = true;
            this.email_msg = res.data.email_msg;
            this.mobile_msg = res.data.mobile_msg;
            this.user.otp_id = res.data.otp_id;
            this.org_list = res.data.org_list || []
            if (this.org_code_from_url) {
              const matchedOrg = this.org_list.find(
                o =>
                  o.org_code &&
                  o.org_code.toLowerCase().trim() ===
                  this.org_code_from_url.toLowerCase().trim()
              );

              if (matchedOrg) {
                this.org = matchedOrg;
                this.org_locked = true;
                this.invalid_org_code = false;
              } else {
                // Invalid ORG_CODE
                this.invalid_org_code = true;
                this.org_locked = true;
              }
        }
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.message = "Something went wrong";
        })
        .finally(() => {
          this.send_otp_btn_load = false;
        });
    },
    verifyotp() {
      //api-2

      // if ((this.user.email_otp != "" || this.is_mobile_signup) && this.org != null) {
      if ((this.user.email_otp != "" || this.user.mobile_otp != "") && this.org != null) {
        this.verify_btn_load = true;
        const formData = {
          email: this.user.email,
          mobile: this.user.mobile,
          email_otp: this.user.email_otp,
          mobile_otp: this.user.mobile_otp,
          org_id: this.org.org_id,
          org_name: this.org.org_name,
          tenant_id: this.org.tenant_id,
        };
        axios
          .post("/login/verifyotp", formData)
          .then((res) => {
            if (res.data.status == "YES") {
              alert(res.data.status_reason);
              this.$router.push("/");
            } else {
              alert(res.data.status_reason);
            }
          })
          .catch((error) => {
            window.console.log(error);
            this.message = "Something went wrong";
          })
          .finally(() => {
            this.verify_btn_load = false;
          });
      } else {
        alert("Please enter otp and select organization!!!");
      }
    },
    perormEmailFormValidation() {
      if (this.user.email == "") {
        return false;
      } else {
        return true;
      }
    },
    perormemail_otpFormValidation() {
      if (this.user.email_otp == "" && this.user.email == "") {
        return false;
      } else {
        return true;
      }
    },
    btndisabled() {
      this.btnDisabled = false;
    },
  },
  mounted() {
    this.init();
    // console.log("FULL PATH:", this.$route.fullPath);
    // console.log("QUERY:", this.$route.query);
    // console.log("ORG_CODE:", this.$route.query.ORG_CODE);
    var url = window.location.href;
    this.message = localStorage.getItem("login-page-msg");
    // this.is_mobile_signup = localStorage.getItem("is_mobile_signup") === "true";
    if (url.includes("vvp.edupluscampus")) {
      this.guid_link =
        "https://eduplusschool.s3.ap-south-1.amazonaws.com/how_to_sign_up_and_fill_online_application_form_vvp.mp4";
    } else if (url.includes("ui-beta")) {
      this.guid_link =
        "https://eduplusschool.s3.ap-south-1.amazonaws.com/how_to_sign_up_and_fill_online_application_form_vvp.mp4";
    } else if (url.includes("localhost")) {
      this.guid_link =
        "https://eduplusschool.s3.ap-south-1.amazonaws.com/how_to_sign_up_and_fill_online_application_form_vvp.mp4";
    } else {
      this.guid_link = null;
            }
            // Example: /parent-signup?ORG_CODE=WWS-HADAPSAR
            this.org_code_from_url = this.$route.query.ORG_CODE || null;

            if (this.org_code_from_url) {
              this.user.org_code = this.org_code_from_url; // send to backend
            }

          },
        };
</script>
<style scoped>
.pull-right {
  position: relative;
  text-align: center;
}
.app {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.button {
  border: 2px solid #0f2027 !important;
  color: #0f2027;
  background: transparent !important;
  border-radius: 50px;
  margin: 0.5rem !important;
}
.button:hover {
  color: white;
  background: #0f2027 !important;
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.note-red {
  color: red;
  text-align: center;
  padding: 12px 0;
  font-weight: 600;
  font-size: 13px;
}
/* ===== Readonly School Dropdown Styling ===== */
.readonly-combobox .v-input__control input {
  color: #000 !important;       /* Black text */
  caret-color: transparent;     /* No blinking cursor */
  cursor: default;
}

/*  REMOVE DROPDOWN ARROW */
.readonly-combobox .v-input__append-inner,
.readonly-combobox .v-select__selection--comma,
.readonly-combobox .v-select__selections + .v-input__append-inner {
  display: none !important;
}

/* Prevent click ripple / focus */
.readonly-combobox .v-input__slot {
  pointer-events: none;
}

</style>
